import React from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { useTranslation } from 'react-i18next';
import { CompositeStatusIconCell, type CompositeStatusIconTooltips } from './compositeStatusIcon';

/**
 * StaticCompositeTable
 *
 * Shared lightweight DataTable atom used by all RTU static-data composite
 * cards (Server Ports, Firewall, Port Forwarding, Virtual IPs).
 */

export interface CompositeColumn {
  field: string;
  header: string;
  width?: string;
  /** Renders a green/red status dot with hover tooltips (column-specific keys). */
  statusTone?: boolean;
  statusIconTooltips?: CompositeStatusIconTooltips;
}

interface Props {
  rows: any[];
  columns: CompositeColumn[];
  emptyMessage?: string;
  className?: string;
}

export const StaticCompositeTable = ({ rows, columns, emptyMessage, className }: Props) => {
  const { t } = useTranslation();

  return (
    <div className="rtu-static-module-card__table-host">
      <DataTable
        value={rows}
        className={`p-datatable-sm rtu-static-composite-table${className ? ` ${className}` : ''}`}
        showGridlines
        size="small"
        style={{ fontSize: '0.8rem' }}
        tableStyle={{ tableLayout: 'auto', width: '100%' }}
        emptyMessage={emptyMessage ?? t('table.noRowsFound', { defaultValue: 'No data.' })}
      >
        {columns.map((col) => (
          <Column
            key={col.field}
            field={col.field}
            header={col.header}
            style={{ whiteSpace: 'nowrap', width: col.width, textAlign: col.statusTone ? 'center' : undefined }}
            headerStyle={col.statusTone ? { textAlign: 'center' } : undefined}
            bodyStyle={col.statusTone ? { textAlign: 'center' } : undefined}
            body={
              col.statusTone && col.statusIconTooltips
                ? (row) => (
                    <CompositeStatusIconCell raw={row[col.field]} tooltips={col.statusIconTooltips!} t={t} />
                  )
                : undefined
            }
          />
        ))}
      </DataTable>
    </div>
  );
};

export default StaticCompositeTable;
